import React from "react";

const ChatMessage = ({color, time, text, isSender}) => {
    return (
        <div
            className={`relative flex flex-col w-fit max-w-80 min-w-20 h-fit mt-4 justify-between rounded-2xl p-5
            ${color} 
            ${isSender ? "ml-auto rounded-tr-none" : "mr-auto rounded-tl-none"} 
                        `}>
            <div className="mb-4">
                <p className="text-gray-800 whitespace-pre-wrap break-words">{text}</p>
            </div>
            <span className="text-xs text-gray-500 absolute bottom-2 right-4">
                {time}
            </span>
        </div>
    );
};

export default ChatMessage;
